/**
 * Hardly Common — Shopify Theme JavaScript
 */

(function() {
  'use strict';

  // ============================================
  // HERO SLIDESHOW
  // ============================================
  const heroSlider = {
    current: 0,
    slides: null,
    dots: null,
    timer: null,
    duration: 6000,

    init() {
      this.slides = document.querySelectorAll('.hero-slide');
      this.dots = document.querySelectorAll('.hero-dot');
      if (this.slides.length < 2) return;

      // Read duration from section setting if available
      const heroEl = document.querySelector('.hero');
      if (heroEl && heroEl.dataset.duration) {
        this.duration = parseInt(heroEl.dataset.duration, 10) * 1000;
      }

      this.startAutoplay();

      // Pause on hover (desktop)
      const slider = document.querySelector('.hero-slider');
      if (slider) {
        slider.addEventListener('mouseenter', () => this.stopAutoplay());
        slider.addEventListener('mouseleave', () => this.startAutoplay());
      }

      // Touch swipe support
      this.initSwipe();
    },

    goTo(index) {
      if (this.slides[this.current]) {
        this.slides[this.current].classList.remove('active');
      }
      if (this.dots[this.current]) {
        this.dots[this.current].classList.remove('active');
      }
      this.current = index;
      if (this.slides[this.current]) {
        this.slides[this.current].classList.add('active');
      }
      if (this.dots[this.current]) {
        this.dots[this.current].classList.add('active');
      }
    },

    next() {
      this.goTo((this.current + 1) % this.slides.length);
    },

    prev() {
      this.goTo((this.current - 1 + this.slides.length) % this.slides.length);
    },

    startAutoplay() {
      this.stopAutoplay();
      this.timer = setInterval(() => this.next(), this.duration);
    },

    stopAutoplay() {
      if (this.timer) clearInterval(this.timer);
    },

    initSwipe() {
      const slider = document.querySelector('.hero-slider');
      if (!slider) return;

      let startX = 0;
      let startY = 0;

      slider.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
      }, { passive: true });

      slider.addEventListener('touchend', (e) => {
        const diffX = startX - e.changedTouches[0].clientX;
        const diffY = startY - e.changedTouches[0].clientY;

        // Only swipe horizontally if the horizontal movement is greater
        if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 50) {
          if (diffX > 0) {
            this.next();
          } else {
            this.prev();
          }
          this.startAutoplay();
        }
      }, { passive: true });
    }
  };

  // Global function for onclick handlers
  window.goSlide = function(index) {
    heroSlider.goTo(index);
    heroSlider.startAutoplay();
  };

  // ============================================
  // SCROLL REVEAL
  // ============================================
  function initReveal() {
    const reveals = document.querySelectorAll('.reveal');
    if (!reveals.length) return;

    // Use IntersectionObserver if available (all modern browsers)
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target); // Only animate once
          }
        });
      }, {
        threshold: 0.12,
        rootMargin: '0px 0px -30px 0px'
      });

      reveals.forEach(el => observer.observe(el));
    } else {
      // Fallback: show all immediately
      reveals.forEach(el => el.classList.add('visible'));
    }
  }

  // ============================================
  // HEADER SHADOW ON SCROLL
  // ============================================
  function initHeaderScroll() {
    const header = document.getElementById('header');
    if (!header) return;

    let ticking = false;

    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          header.style.boxShadow = window.pageYOffset > 60
            ? '0 2px 24px rgba(0,0,0,0.06)'
            : 'none';
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  // ============================================
  // MOBILE MENU
  // ============================================
  function initMobileMenu() {
    const nav = document.getElementById('mobileNav');
    const overlay = document.getElementById('mobileOverlay');
    if (!nav || !overlay) return;

    window.toggleMobile = function() {
      const isOpen = nav.classList.contains('open');

      nav.classList.toggle('open');
      overlay.classList.toggle('open');
      document.body.style.overflow = isOpen ? '' : 'hidden';

      // Accessibility
      const toggle = document.getElementById('mobileToggle');
      if (toggle) {
        toggle.setAttribute('aria-expanded', !isOpen);
      }
    };

    // Close on Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && nav.classList.contains('open')) {
        window.toggleMobile();
      }
    });
  }

  // ============================================
  // SMOOTH SCROLL FOR ANCHOR LINKS
  // ============================================
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function(e) {
        const target = document.querySelector(this.getAttribute('href'));
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  // ============================================
  // INITIALIZE
  // ============================================
  function init() {
    heroSlider.init();
    initReveal();
    initHeaderScroll();
    initMobileMenu();
    initSmoothScroll();
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
